import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IDataGridPageRequest, convertObjectToGetParams } from "@siu/shared";
import { environment } from "src/environments/environment";
import { IFormBuscarRastreo } from "../pages/reporte-rastreo/store/reporte-rastreo.store.interface";
import { IFormBuscarDetalleVentaTurno } from "../pages/reporte-detalle-venta-turno/store/reporte-detalle-venta-turno.store.interface";
import { IFormBuscarConsolidadoVentaTurno } from "../pages/reporte-consolidado-venta-turno/store/reporte-consolidado-venta-turno.store.interface";
import { IFormBuscarConsolidadoVentaDia } from "../pages/reporte-consolidado-venta-dia/store/reporte-consolidado-venta-dia.store.interface";
import { IFormBuscarConsolidadoRecaudacion } from "../pages/reporte-consolidado-recaudacion/store/reporte-consolidado-recaudacion.store.interface";
import { IGenerarReporteRastreoVehicularRequest } from "./../pages/reporte-rastreo/store/reporte-rastreo.store.interface";
import { IFormBuscarVisor } from "../pages/reporte-visor/store/reporte-visor.store.interface";

@Injectable()
export class ReportesService {
  private url: string = `${environment.apiGatewayAddress}/b/v1/Bonificacion`;
  private urlPeajesReportes: string = `${environment.apiGatewayAddress}/p/v1/Reportes`;

  constructor(private http: HttpClient) {}

  fetchReporteVisor = (
    pageRequest: IDataGridPageRequest,
    value: IFormBuscarVisor
  ): Observable<any> => {
    const data = {
      page: pageRequest.page,
      pageSize: pageRequest.pageSize,
      skip: pageRequest.skip,
      sortField: pageRequest.orderBy,
      sortDir: pageRequest.orderDir,
      filter: value,
    };

    const params = convertObjectToGetParams(data);

    return this.http.get(`${this.url}/ReportesRastreo-Buscar`, { params });
  };

  fetchReporteRastreo = (
    pageRequest: IDataGridPageRequest,
    value: IFormBuscarRastreo
  ): Observable<any> => {
    const data = {
      page: pageRequest.page,
      pageSize: pageRequest.pageSize,
      skip: pageRequest.skip,
      sortField: pageRequest.orderBy,
      sortDir: pageRequest.orderDir,
      filter: value,
    };

    const params = convertObjectToGetParams(data);

    return this.http.get(`${this.url}/ReportesRastreo-Buscar`, { params });
  };

  generarReporteRastreoVehicular = (
    value: IGenerarReporteRastreoVehicularRequest
  ): Observable<any> => {
    return this.http.post(
      `${this.urlPeajesReportes}/generar-rastreo-vehicular`,
      {
        request: value,
      }
    );
  };

  fetchReporteDetalleVentaTurno = (
    pageRequest: IDataGridPageRequest,
    value: IFormBuscarDetalleVentaTurno
  ): Observable<any> => {
    const data = {
      page: pageRequest.page,
      pageSize: pageRequest.pageSize,
      skip: pageRequest.skip,
      sortField: pageRequest.orderBy,
      sortDir: pageRequest.orderDir,
      filter: value,
    };

    const params = convertObjectToGetParams(data);

    return this.http.get(`${this.url}/ReportesDetalleVentaTurno-Buscar`, {
      params,
    });
  };

  fetchReporteConsolidadoVentaTurno = (
    pageRequest: IDataGridPageRequest,
    value: IFormBuscarConsolidadoVentaTurno
  ): Observable<any> => {
    const data = {
      page: pageRequest.page,
      pageSize: pageRequest.pageSize,
      skip: pageRequest.skip,
      sortField: pageRequest.orderBy,
      sortDir: pageRequest.orderDir,
      filter: value,
    };

    const params = convertObjectToGetParams(data);

    return this.http.get(`${this.url}/ReportesConsolidadoVentaTurno-Buscar`, {
      params,
    });
  };

  fetchReporteConsolidadoVentaDia = (
    pageRequest: IDataGridPageRequest,
    value: IFormBuscarConsolidadoVentaDia
  ): Observable<any> => {
    const data = {
      page: pageRequest.page,
      pageSize: pageRequest.pageSize,
      skip: pageRequest.skip,
      sortField: pageRequest.orderBy,
      sortDir: pageRequest.orderDir,
      filter: value,
    };

    const params = convertObjectToGetParams(data);

    return this.http.get(`${this.url}/ReportesConsolidadoVentaDia-Buscar`, {
      params,
    });
  };

  fetchReporteConsolidadoRecaudacion = (
    pageRequest: IDataGridPageRequest,
    value: IFormBuscarConsolidadoRecaudacion
  ): Observable<any> => {
    const data = {
      page: pageRequest.page,
      pageSize: pageRequest.pageSize,
      skip: pageRequest.skip,
      sortField: pageRequest.orderBy,
      sortDir: pageRequest.orderDir,
      filter: value,
    };

    const params = convertObjectToGetParams(data);

    return this.http.get(`${this.url}/ReportesConsolidadoRecaudacion-Buscar`, {
      params,
    });
  };

  //#region EXPEDIENTES
  fetchReporteExpediente = (
    pageRequest: IDataGridPageRequest,
    value: IFormBuscarVisor
  ): Observable<any> => {
    const data = {
      page: pageRequest.page,
      pageSize: pageRequest.pageSize,
      skip: pageRequest.skip,
      sortField: pageRequest.orderBy,
      sortDir: pageRequest.orderDir,
      filter: value,
    };

    const params = convertObjectToGetParams(data);

    return this.http.get(`${this.url}/ReportesExpediente-Buscar`, { params });
  };
  //#endregion
}
